import * as types from '../constants/ActionTypes'
//import _ from 'lodash'
let initState = {
	User: {
		name: '',
		token: null,
		practices: [],
		ownPractices: [],
		terms_conditions: false,
		signedInUrl: '',
	},
	pendingCred: null,
	existingProviderName: '',
	newProviderName: ''
}


export default function User(state = initState, action) {
	switch (action.type) {
		case types.SET_USER_ACCOUNT_EXISTS_CREDS:
			return {
				...state,
				pendingCred: action.payload.credential,
				newProviderName: action.payload.p,
				existingProviderName: action.payload.p === 'Google' ? 'Facebook' : 'Google'
			}

		case types.SET_USER:
			{
					let u = {...action.user}
					u.displayName = u.displayName || u.name;
					u.user_id = u.uid || u.user_id;
					u.photoURL = u.photoURL || u.picture;
					let user = {...state.User, ...u}
					//user = Object.assign(user, u);
					
					return {
						...state,
						User: user
					}
			}


		case types.ADD_PRACTICE_TO_USER:
			{
				let practices = [...new Set(state.User.practices.concat(action.payload))];
				let user = {...state.User, practices: practices };
				return {
					...state,
					User: user
				}
			}

		case types.REMOVE_USER:
			return initState


		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/User.js